import React from "react";
import { Route } from "react-router-dom";
import { usePrevState } from "../../context/PrevStateProvider";

export default function RouteWithState({ children, ...rest }) {
  const { prevState } = usePrevState();

  return (
    <Route
      {...rest}
      render={({ location }) => React.cloneElement(children, { prevState })}
    />
  );
}
